import {
    ADD_BOOKING_REQUEST,
    ADD_BOOKING_SUCCESS,
    ADD_BOOKING_FAILURE,
    ADD_BOOKING_RESET,
    GET_CUSTOMER_REQUEST,
    GET_CUSTOMER_SUCCESS,
    GET_CUSTOMER_FAILURE,
    GET_VEHICLE_TYPES_REQUEST,
    GET_VEHICLE_TYPES_SUCCESS,
    GET_VEHICLE_TYPES_FAILURE,
    GET_TRIP_TYPES_REQUEST,
    GET_TRIP_TYPES_SUCCESS,
    GET_TRIP_TYPES_FAILURE,
    GET_INTERCITY_LIST_REQUEST,
    GET_INTERCITY_LIST_SUCCESS,
    GET_INTERCITY_LIST_FAILURE,
    GET_RETURN_INTERCITY_REQUEST,
    GET_RETURN_INTERCITY_SUCCESS,
    GET_RETURN_INTERCITY_FAILURE,
    GET_GOODS_TYPES_REQUEST,
    GET_GOODS_TYPES_SUCCESS,
    GET_GOODS_TYPES_FAILURE,
    GET_LOCATIONS_REQUEST,
    GET_LOCATIONS_SUCCESS,
    GET_LOCATIONS_FAILURE,
    GET_AVAILABLE_CABS_REQUEST,
    GET_AVAILABLE_CABS_SUCCESS,
    GET_AVAILABLE_CABS_FAILURE,
    GET_METER_FARE_REQUEST,
    GET_METER_FARE_SUCCESS,
    GET_METER_FARE_FAILURE,
    GET_PACKAGES_REQUEST,
    GET_PACKAGES_SUCCESS,
    GET_PACKAGES_FAILURE,
    GET_BRANCHES_REQUEST,
    GET_BRANCHES_SUCCESS,
    GET_BRANCHES_FAILURE,
    ADD_ENQUIRY_REQUEST,
    ADD_ENQUIRY_SUCCESS,
    ADD_ENQUIRY_FAILURE,
    ADD_ENQUIRY_RESET,
    GET_NIGHT_FARE_REQUEST,
    GET_NIGHT_FARE_SUCCESS,
    GET_NIGHT_FARE_FAILURE,
    GET_ENQUIRY_BY_DATE_REQUEST,
    GET_ENQUIRY_BY_DATE_SUCCESS,
    GET_ENQUIRY_BY_DATE_FAILURE,
    ENQUIRY_TO_NEW_BOOKING_REQUEST,
    ENQUIRY_TO_NEW_BOOKING_SUCCESS,
    ENQUIRY_TO_NEW_BOOKING_FAILURE,
    ENQUIRY_TO_NEW_BOOKING_RESET,
    GET_DISTANCE_REQUEST,
    GET_DISTANCE_SUCCESS,
    GET_DISTANCE_FAILURE,
    RESET_FARE_ESTIMATE,
    GET_NEW_BOOKING_EDIT_REQUEST,
    GET_NEW_BOOKING_EDIT_SUCCESS,
    GET_NEW_BOOKING_EDIT_FAILURE,
    GET_NEW_BOOKING_EDIT_RESET,
    CLEAR_FARE_LISTS,
    UPDATE_ENQUIRY_REQUEST,
    UPDATE_ENQUIRY_SUCCESS,
    UPDATE_ENQUIRY_FAILURE,
    ENQUIRY_ASSIGN_TRIP_REQUEST,
    ENQUIRY_ASSIGN_TRIP_SUCCESS,
    ENQUIRY_ASSIGN_TRIP_FAILURE,
    ENQUIRY_ASSIGN_TRIP_RESET,
} from "../actions/bookingActions";

interface BookingState {
    loading: boolean;
    success: boolean;
    message: string | null;
    error: string | null;
    customerData: any | null;
    vehicleTypes: any[];
    tripTypes: any[];
    goodsTypes: any[];
    locations: any[];
    availableCabs: any[];
    fareEstimate: any | null;
    intercityList: any[];
    returnIntercityList: any[];
    packages: any[];
    branches: any[];
    branchesLoading: boolean;
    branchesError: string | null;
    nightFare: any[];
    enquiryLoading: boolean;
    enquirySuccess: boolean;
    enquiryError: string | null;
    enquiries: any[];
    enquiriesLoading: boolean;
    enquiriesError: string | null;
    enquiriesCount: number;
    enqToBookingLoading: boolean;
    enqToBookingSuccess: boolean;
    enqToBookingError: string | null;
    distance: any | null;
    distanceLoading: boolean;
    addBookingLoading: boolean;
    addBookingError: string | null;
    availableCabsError: string | null;
    companies: any[];
    editBooking: any | null;
    editBookingLoading: boolean;
    editBookingError: string | null;
    updateEnquiryLoading: boolean;
    updateEnquirySuccess: boolean;
    updateEnquiryError: string | null;
    enquiryAssignLoading: boolean;
    enquiryAssignSuccess: boolean;
    enquiryAssignError: string | null;
}

const initialState: BookingState = {
    loading: false,
    success: false,
    message: null,
    error: null,
    customerData: null,
    vehicleTypes: [],
    tripTypes: [],
    goodsTypes: [],
    locations: [],
    availableCabs: [],
    fareEstimate: null,
    intercityList: [],
    returnIntercityList: [],
    packages: [],
    branches: [],
    branchesLoading: false,
    branchesError: null,
    nightFare: [],
    enquiryLoading: false,
    enquirySuccess: false,
    enquiryError: null,
    enquiries: [],
    enquiriesLoading: false,
    enquiriesError: null,
    enquiriesCount: 0,
    enqToBookingLoading: false,
    enqToBookingSuccess: false,
    enqToBookingError: null,
    distance: null,
    distanceLoading: false,
    addBookingLoading: false,
    addBookingError: null,
    availableCabsError: null,
    companies: [],
    editBooking: null,
    editBookingLoading: false,
    editBookingError: null,
    updateEnquiryLoading: false,
    updateEnquirySuccess: false,
    updateEnquiryError: null,
    enquiryAssignLoading: false,
    enquiryAssignSuccess: false,
    enquiryAssignError: null,
};

export default function bookingReducer(
    state = initialState,
    action: any
): BookingState {
    switch (action.type) {
        // ADD Booking
        case ADD_BOOKING_REQUEST:
            return { ...state, addBookingLoading: true, error: null, addBookingError: null, success: false };
        case ADD_BOOKING_SUCCESS:
            return { ...state, addBookingLoading: false, success: true, addBookingError: null, customerData: null };
        case ADD_BOOKING_FAILURE:
            return { ...state, addBookingLoading: false, error: action.payload, addBookingError: action.payload };
        case ADD_BOOKING_RESET:
            return { ...state, loading: false, addBookingLoading: false, success: false, error: null, addBookingError: null, customerData: null };

        // ADD ENQUIRY
        case ADD_ENQUIRY_REQUEST:
            return { ...state, enquiryLoading: true, enquirySuccess: false, enquiryError: null };
        case ADD_ENQUIRY_SUCCESS:
            return { ...state, enquiryLoading: false, enquirySuccess: true, enquiryError: null };
        case ADD_ENQUIRY_FAILURE:
            return { ...state, enquiryLoading: false, enquirySuccess: false, enquiryError: action.payload };
        case ADD_ENQUIRY_RESET:
            return { ...state, enquiryLoading: false, enquirySuccess: false, enquiryError: null, customerData: null };

        // GET BRANCHES
        // Uses its own loading/error keys on purpose: BookingLayout fetches
        // branches on every page load, and Add.tsx renders the slice-wide
        // `error` as a toast (Add.tsx:746-747), so writing the shared keys here
        // would pop a spurious error on the booking form.
        case GET_BRANCHES_REQUEST:
            return { ...state, branchesLoading: true, branchesError: null };
        case GET_BRANCHES_SUCCESS:
            return {
                ...state,
                branchesLoading: false,
                branchesError: null,
                branches: Array.isArray(action.payload) ? action.payload : [],
            };
        case GET_BRANCHES_FAILURE:
            return { ...state, branchesLoading: false, branchesError: action.payload };

        // GET CUSTOMER
        case GET_CUSTOMER_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_CUSTOMER_SUCCESS:
            return { ...state, loading: false, customerData: action.payload };
        case GET_CUSTOMER_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case "CLEAR_CUSTOMER_DATA":
            return { ...state, customerData: null };

        // GET VEHICLE TYPES
        case GET_VEHICLE_TYPES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_VEHICLE_TYPES_SUCCESS:
            return { ...state, loading: false, vehicleTypes: action.payload };
        case GET_VEHICLE_TYPES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET TRIP TYPES
        case GET_TRIP_TYPES_REQUEST:
            return { ...state, loading: true, error: null, packages: [], nightFare: [], intercityList: [], fareEstimate: null };
        case GET_TRIP_TYPES_SUCCESS:
            return { ...state, loading: false, tripTypes: action.payload };
        case GET_TRIP_TYPES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET RETURN INTERCITY LIST
        case GET_RETURN_INTERCITY_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_RETURN_INTERCITY_SUCCESS:
            return { ...state, loading: false, returnIntercityList: action.payload };
        case GET_RETURN_INTERCITY_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET GOODS TYPES
        case GET_GOODS_TYPES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_GOODS_TYPES_SUCCESS:
            return { ...state, loading: false, goodsTypes: action.payload };
        case GET_GOODS_TYPES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET LOCATIONS
        case GET_LOCATIONS_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_LOCATIONS_SUCCESS:
            return { ...state, loading: false, locations: action.payload };
        case GET_LOCATIONS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET AVAILABLE CABS
        case GET_AVAILABLE_CABS_REQUEST:
            return { ...state, loading: true, availableCabsError: null };
        case GET_AVAILABLE_CABS_SUCCESS:
            return { ...state, loading: false, availableCabs: action.payload, availableCabsError: null };
        // getcabsonduty answers 404 "No cabs available" when the branch has
        // none on duty, which is a normal state, not a page error. It used to
        // land in the shared `error`, where the Add page read it as "the
        // booking failed" right after a booking succeeded.
        case GET_AVAILABLE_CABS_FAILURE:
            return { ...state, loading: false, availableCabs: [], availableCabsError: action.payload };

        // GET METER FARE
        case GET_METER_FARE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_METER_FARE_SUCCESS:
            return { ...state, loading: false, fareEstimate: action.payload?.[0] || action.payload };
        case GET_METER_FARE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET PACKAGES
        case GET_PACKAGES_REQUEST:
            return { ...state, loading: true, error: null, fareEstimate: null, nightFare: [], intercityList: [], packages: [] };
        case GET_PACKAGES_SUCCESS:
            return { ...state, loading: false, packages: action.payload };
        case GET_PACKAGES_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET INTERCITY LIST
        case GET_INTERCITY_LIST_REQUEST:
            return { ...state, loading: true, error: null, fareEstimate: null, packages: [], nightFare: [], intercityList: [] };
        case GET_INTERCITY_LIST_SUCCESS:
            return { ...state, loading: false, intercityList: action.payload };
        case GET_INTERCITY_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET NIGHT FARE
        case GET_NIGHT_FARE_REQUEST:
            return { ...state, loading: true, error: null, fareEstimate: null, packages: [], intercityList: [] };
        case GET_NIGHT_FARE_SUCCESS:
            return { ...state, loading: false, nightFare: action.payload };
        case GET_NIGHT_FARE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        // GET ENQUIRY BY DATE
        case GET_ENQUIRY_BY_DATE_REQUEST:
            return { ...state, enquiriesLoading: true, enquiriesError: null };
        case GET_ENQUIRY_BY_DATE_SUCCESS:
            return {
                ...state,
                enquiriesLoading: false,
                enquiries: Array.isArray(action.payload.data) ? action.payload.data : [],
                enquiriesCount: action.payload.tablelength || 0,
            };
        case GET_ENQUIRY_BY_DATE_FAILURE:
            return { ...state, enquiriesLoading: false, enquiriesError: action.payload, enquiries: [], enquiriesCount: 0 };

        //update enquiry
        case UPDATE_ENQUIRY_REQUEST:
            return { ...state, updateEnquiryLoading: true, updateEnquirySuccess: false, updateEnquiryError: null };
        case UPDATE_ENQUIRY_SUCCESS:
            return { ...state, updateEnquiryLoading: false, updateEnquirySuccess: true, updateEnquiryError: null };
        case UPDATE_ENQUIRY_FAILURE:
            return { ...state, updateEnquiryLoading: false, updateEnquirySuccess: false, updateEnquiryError: action.payload };
        case "UPDATE_ENQUIRY_RESET":
            return { ...state, updateEnquiryLoading: false, updateEnquirySuccess: false, updateEnquiryError: null };

        // ENQUIRY TO NEW BOOKING
        case ENQUIRY_TO_NEW_BOOKING_REQUEST:
            return { ...state, enqToBookingLoading: true, enqToBookingSuccess: false, enqToBookingError: null };
        case ENQUIRY_TO_NEW_BOOKING_SUCCESS:
            return { ...state, enqToBookingLoading: false, enqToBookingSuccess: true, enqToBookingError: null };
        case ENQUIRY_TO_NEW_BOOKING_FAILURE:
            return { ...state, enqToBookingLoading: false, enqToBookingSuccess: false, enqToBookingError: action.payload };
        case ENQUIRY_TO_NEW_BOOKING_RESET:
            return { ...state, enqToBookingLoading: false, enqToBookingSuccess: false, enqToBookingError: null };

        // ENQUIRY ASSIGN TRIP
        case ENQUIRY_ASSIGN_TRIP_REQUEST:
            return { ...state, enquiryAssignLoading: true, enquiryAssignSuccess: false, enquiryAssignError: null };
        case ENQUIRY_ASSIGN_TRIP_SUCCESS:
            return { ...state, enquiryAssignLoading: false, enquiryAssignSuccess: true, enquiryAssignError: null };
        case ENQUIRY_ASSIGN_TRIP_FAILURE:
            return { ...state, enquiryAssignLoading: false, enquiryAssignSuccess: false, enquiryAssignError: action.payload };
        case ENQUIRY_ASSIGN_TRIP_RESET:
            return { ...state, enquiryAssignLoading: false, enquiryAssignSuccess: false, enquiryAssignError: null };

        case GET_DISTANCE_REQUEST:
            return { ...state, distanceLoading: true, error: null, fareEstimate: null, packages: [], nightFare: [], intercityList: [] };
        case GET_DISTANCE_SUCCESS:
            return { ...state, distanceLoading: false, distance: action.payload };
        case GET_DISTANCE_FAILURE:
            return { ...state, distanceLoading: false, error: action.payload };
        case RESET_FARE_ESTIMATE:
            return { ...state, fareEstimate: null, packages: [], nightFare: [], intercityList: [], distance: null };

        case "GET_COMPANIES_REQUEST":
            return { ...state, loading: true, error: null };
        case "GET_COMPANIES_SUCCESS":
            return { ...state, loading: false, companies: action.payload };
        case "GET_COMPANIES_FAILURE":
            return { ...state, loading: false, error: action.payload };

        case GET_NEW_BOOKING_EDIT_REQUEST:
            return { ...state, editBookingLoading: true, editBookingError: null, editBooking: null };
        case GET_NEW_BOOKING_EDIT_SUCCESS:
            return { ...state, editBookingLoading: false, editBooking: action.payload };
        case GET_NEW_BOOKING_EDIT_FAILURE:
            return { ...state, editBookingLoading: false, editBookingError: action.payload };
        case GET_NEW_BOOKING_EDIT_RESET:
            return { ...state, editBooking: null, editBookingLoading: false, editBookingError: null };

        case CLEAR_FARE_LISTS:
            return {
                ...state,
                packages: [],
                nightFare: [],
                intercityList: [],
                fareEstimate: null,
                distance: null,
            };

        default:
            return state;
    }
}
